
import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Product } from '@/lib/types';
import { getAlertSettings } from '@/lib/storage/alertStorage';

export const useAlerts = () => {
  const [dismissedAlerts, setDismissedAlerts] = useState<string[]>([]);
  const [alertSettings] = useState(getAlertSettings());
  const navigate = useNavigate();

  const handleDismissAlert = useCallback((productId: string) => {
    setDismissedAlerts(prev => [...prev, productId]);
  }, []);

  const handleAddStock = useCallback((product: Product) => {
    navigate(`/products?action=addStock&productId=${product.id}`);
  }, [navigate]);

  return {
    dismissedAlerts,
    alertSettings,
    handleDismissAlert,
    handleAddStock
  };
};
